import { useEffect } from "react";
import Lenis from "lenis";
import { useReducedMotion } from "./hooks";

/** 페이지 전역 관성 스크롤. 모션 축소 설정이면 붙이지 않는다. */
export default function useSmoothScroll() {
	const reduced = useReducedMotion();

	useEffect(() => {
		if (reduced) return undefined;

		const lenis = new Lenis({
			duration: 1.05,
			easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
			smoothWheel: true,
			touchMultiplier: 1.6,
		});

		let frame;
		const raf = (time) => {
			lenis.raf(time);
			frame = requestAnimationFrame(raf);
		};
		frame = requestAnimationFrame(raf);

		return () => {
			cancelAnimationFrame(frame);
			lenis.destroy();
		};
	}, [reduced]);
}
